export default "__VITE_PUBLIC_ASSET__530dd6b6__"